//#region imports
import React from 'react';

// styling
import styled from 'styled-components';

// constants
import { TimelineColumnWidth, Timeline30MinLayoutColumnWidth, TimelineColumnHeight } from '../timeline-constants';

//#endregion

//#region styled div
const TimelineColumnDiv = styled.div`
  border: 1px solid lightgrey;
  min-width: ${Timeline30MinLayoutColumnWidth}; 
  height: ${TimelineColumnHeight};
  min-height: ${TimelineColumnHeight};
  max-height: ${TimelineColumnHeight};
  text-align:'center';
  &:hover {
    background-color: #e0dede !important;
  }
`;
//#endregion

const TimelineColumnContainer = React.memo((props) => {
    return (
        <TimelineColumnDiv
            style={{
                display: 'flex',
                flex: 1,
                borderStyle: 'solid', borderWidth: 1,
                width: props?.is30MinLayout ? Timeline30MinLayoutColumnWidth : TimelineColumnWidth,
                height: TimelineColumnHeight,
                minHeight: TimelineColumnHeight,
                maxHeight: TimelineColumnHeight,
                position: "relative",
                border: '1px solid lightgrey',
                backgroundColor: props.backgroundColor,
                background: props.background || props.backgroundColor,
                borderColor: props.borderColor,
                minWidth: props?.is30MinLayout ? Timeline30MinLayoutColumnWidth : TimelineColumnWidth,
                cursor: 'pointer',
            }}
            onClick={props.onClick}
        >
            {props.children}
        </TimelineColumnDiv>
    );
});

export default TimelineColumnContainer;
